import React from 'react'
import * as S from "./style"
import {FaFacebook, FaInstagram, FaTwitter, FaSpotify} from "react-icons/fa"

export const Redes = () => {
    return (
        <S.Container>

            <h4>Siga nossas redes</h4>

            <div className="wrapper">
                <FaFacebook className="icone"/>
                <FaInstagram className="icone"/>
                <FaTwitter className="icone"/>
                <FaSpotify className="icone"/>
            </div>

        </S.Container>
    )
}
